import { AnaliseDeCreditoController } from "../../../Controllers/Vendas/AnaliseDeCredito/AnaliseDeCreditoControllers";
import { IAnalisesDeCreditoBody } from "../../../Interfaces/Vendas/GestaoAtendimentos/AnaliseDeCredito/AnaliseDeCreditoInterfaces";
import useAsyncEffect from "../../../hooks/useAsyncEffect";
import usePaginationFilter from "../../../hooks/usePaginationFilter";
import { ColumnDescription } from "react-bootstrap-table-next";
import Table from "../../Table";
import CardViewAnaliseDeCredito from "../../../Pages/Vendas/AnaliseDeCredito/CardViewAnaliseDeCredito";
import { IAnalisesDeCredito } from "../../../Interfaces/Vendas/GestaoAtendimentos/AnaliseDeCredito/AnaliseDeCreditoInterfaces";

interface IAnaliseCreditoProps {
    ID_CASO: number;
}

export default function AnaliseCredito(props: IAnaliseCreditoProps) {
    const { PageFilter, setPage } = usePaginationFilter<IAnalisesDeCreditoBody>(
        { page: 1 }
    );

    const { value: AnaliseDeCreditoLst, loading: AnaliseDeCreditoLstLoading } =
        useAsyncEffect(async () => {
            return AnaliseDeCreditoController(PageFilter.page, {
                ID_CASO: props.ID_CASO,
            });
        }, [PageFilter, props.ID_CASO]);

    const totalPaginas = AnaliseDeCreditoLst?.NR_PAGINAS || 1;

    const dataColumns: Array<ColumnDescription> = [
        {
            dataField: "ID_RESERVA",
            text: "Analise de Crédito",
            headerStyle: {
                fontWeight: "Bold",
                fontSize: "18px",
            },
            formatter: (c, row) => <CardViewAnaliseDeCredito {...row} />,
        },
    ];

    const tableViewColumns: Array<ColumnDescription<IAnalisesDeCredito>> = [
        {
            dataField: "ID_CASO",
            text: "ID",
            headerClasses: "font-size-h8 font-weight-bold",
        },
        {
            dataField: "DT_CRIACAO",
            text: "Data de Criação",
            headerClasses: "font-size-h8 font-weight-bold",
            formatter: (c, row) => (
                <div>{new Date(row.DT_CRIACAO).toLocaleString()}</div>
            ),
        },
        {
            dataField: "DT_VALIDADE",
            text: "Data de Validade",
            headerClasses: "font-size-h8 font-weight-bold",
            formatter: (c, row) => (
                <div>{new Date(row.DT_VALIDADE).toLocaleString()}</div>
            ),
        },
        {
            dataField: "DT_ULTIMA_ALTERACAO",
            text: "Data da Última Alteração",
            headerClasses: "font-size-h8 font-weight-bold",
            formatter: (c, row) => (
                <div>{new Date(row.DT_ULTIMA_ALTERACAO).toLocaleString()}</div>
            ),
        },
        {
            dataField: "DS_USUARIO_RESPONSAVEL",
            text: "Responsável",
            headerClasses: "font-size-h8 font-weight-bold",
            formatter: (c, row) => <div>{row.DS_USUARIO_RESPONSAVEL}</div>,
        },
        {
            dataField: "DS_STATUS",
            text: "Análise",
            headerClasses: "font-size-h8 font-weight-bold",
            formatter: (c, row) => (
                <div>
                    <div style={{ color: CorDaAnalise(row), fontSize: 16 }}>
                        {row.DS_STATUS}
                    </div>
                    {row.DS_ANALISE_CREDITO_STATUS && (
                        <div>Sub-Status: {row.DS_ANALISE_CREDITO_STATUS}</div>
                    )}
                </div>
            ),
        },
    ];

    function CorDaAnalise(row: IAnalisesDeCredito) {
        if (row.DS_STATUS === "REPROVADA") {
            return "red";
        } else if (row.DS_STATUS === "APROVADA") {
            return "green";
        } else if (row.DS_STATUS === "PENDÊNCIA") {
            return "DarkMagenta";
        } else if (row.DS_STATUS === "EM ANÁLISE") {
            return "blue";
        }
    }

    return (
        <div className="card card-custom w-auto gutter-b">
            <>
                <Table
                    keyField="ID_CASO"
                    columns={dataColumns}
                    wrapperClasses="mw-100 custom-scroll"
                    tableView={{
                        columns: tableViewColumns,
                        sizePerPage: 10,
                        cancelYScroll: true,
                        defaultStyle: true,
                        striped: true,
                    }}
                    remote={{ pagination: true }}
                    data={AnaliseDeCreditoLst?.Analises || []}
                    loading={AnaliseDeCreditoLstLoading}
                    onTableChange={(type, newState) => {
                        setPage(newState.page);
                    }}
                    totalPages={totalPaginas}
                    noDataIndication={() => (
                        <div className="text-black-50 text-center">
                            Nenhuma análise de crédito encontrada
                        </div>
                    )}
                    rowStyle={{ height: 80 }}
                    bordered={false}
                    defaultStyle={{ align: "center" }}
                    striped={false}
                    rowClasses={"rowClasses"}
                />
            </>
        </div>
    );
}
